<template>
  <div>
    <form data-vv-scope="uploadFiles">
      <div class="row">
        <div class="col-9 mt-5">
          <div class="d-flex">
            <b-form-select
              class="w-100 mt-2 mr-4"
              v-model="uploadType"
              :options="optionsUploadTypes"
            />
            <UploadFile
              data-cy="file-upload"
              class="mt-2 mr-3"
              permission="*"
              :accept="uploadType === 'main' ? 'application/pdf' : ''"
              text="Seleccionar"
              v-model="newFile"
              upload-to="ed"
              v-tooltip="'Agregar archivo adjunto'"
              @input="addNewFile()"
            />
          </div>
          <div v-if="!!error">
            <small class="text-danger">{{error}}</small>
          </div>
        </div>
        <div class="col-12 mt-5" v-if="thereIsMainFile">
          <b-table-simple hover small>
            <b-thead>
              <b-tr>
                <b-th scope="col">Nombre archivo</b-th>
                <b-th scope="col">Nombre documento</b-th>
                <b-th scope="col" class="text-center">Acción</b-th>
                <b-th
                  v-if="withTrueCopy || $route.params.from === 'edit'"
                  scope="col"
                  class="text-center"
                >
                  Tipo
                </b-th>
              </b-tr>
            </b-thead>
            <b-tr>
              <b-td>
                <div v-tooltip="'Principal'" class="d-flex align-items-center">
                  <vs-icon icon="file_present" size="medium" class="mr-1"/>
                  {{mainFile.name}}
                </div>
              </b-td>
              <b-td>
                <vs-input class="w-100" v-model="mainFile.currentDescription"/>
              </b-td>
              <b-td></b-td>
              <b-td v-if="withTrueCopy || $route.params.from === 'edit'" class="text-center">
                <b-form-select v-model="mainFile.trueCopy" :options="trueCopyOptions">
                </b-form-select>
              </b-td>
            </b-tr>
            <b-tr v-for="file in additionalFiles" :key="file.id">
              <b-td>
                <div v-tooltip="'Adjunto'" class="d-flex align-items-center">
                  <vs-icon icon="description" size="medium" class="mr-1" />
                  {{file.name}}
                </div>
              </b-td>
              <b-td>
                <vs-input class="w-100" v-model="file.currentDescription"/>
              </b-td>
              <b-td class="text-center">
                <vs-icon
                  class="cursor-pointer"
                  color="danger"
                  data-cy="remove-attachment"
                  icon="remove_circle_outline"
                  size="small"
                  v-tooltip="'Eliminar'"
                  @click="removeAdditionalFile(file.id)"
                />
              </b-td>
              <b-td v-if="withTrueCopy || $route.params.from === 'edit'" class="text-center">
                <b-form-select v-model="file.trueCopy" :options="trueCopyOptions">
                </b-form-select>
              </b-td>
            </b-tr>
          </b-table-simple>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  name: 'loadFilesNew',
  components: { UploadFile },
  props: {
    values: {
      type: Array
    },
    withTrueCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      additionalFile: {},
      additionalFiles: [],
      error: '',
      isPaper: 'Papel',
      mainFile: {},
      newFile: {},
      trueCopyOptions: [
        { text: 'Papel', value: 'Papel' },
        { text: 'Digital', value: 'Digital' }
      ],
      uploadType: 'main',
      uploadTypes: [
        {
          value: 'main',
          text: 'Seleccionar archivo principal (Nuevo)'
        },
        {
          value: 'attached',
          text: 'Seleccionar archivo adjunto (Nuevo)'
        }
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    optionsUploadTypes() {
      if (this.isSiss) {
        this.setModelUploadType('attached');
        return this.uploadTypes.filter((type) => type.value !== 'main');
      }
      return this.uploadTypes;
    },
    thereIsMainFile() {
      return !!Object.keys(this.mainFile)?.length;
    }
  },
  methods: {
    setModelUploadType(type) {
      this.uploadType = type;
    },
    removeAdditionalFile(fileId) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: '¿Estás seguro que deseas eliminar el archivo adjunto?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.additionalFiles = this.additionalFiles.filter((file) => file.id !== fileId)
      });
    },
    addNewFile() {
      if (!Object.keys(this.newFile).length) return;
      if (this.newFile.failed) {
        this.error = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      if (this.withTrueCopy) this.newFile.trueCopy = this.isPaper;

      if (this.uploadType === 'main') {
        this.mainFile = this.newFile;
      } else {
        this.additionalFiles.push(this.newFile);
      }
      this.error = '';
    },
    getFiles() {
      return {
        mainFile: this.mainFile,
        additionalFiles: this.additionalFiles
      };
    }
  },
  created() {
    this.values.forEach((file) => {
      const formatType = {
        currentDescription: file.tipoDescripcion,
        date: file.fecha,
        id: file.adjuntoId,
        name: file.adjuntoNombre,
        mime: file.adjuntoMime,
        path: file.adjuntoUrl,
        status: file.estado || 0,
        trueCopy: file.otraReferenciaId
      };
      if (file.tipo === 'principal') {
        this.mainFile = formatType;
      } else {
        this.additionalFiles.push(formatType);
      }
    });
  }
};
</script>
